import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { action } from './propTypes';

import { connect } from 'react-redux';

import {
  getPreviewChanges,
  getPreviewModalMode,
  getPreviewModalLoading,
  getPreviewModalSubmitting,
} from 'redux/modules/recurring-orders-edit/selectors';

import { EDIT } from './constants';

import { Modal, Button, Link, Flexer, Text, Spacer } from '@ontruck/orc';

import { StyledLoading } from 'modules/Common/form/styled';

import ROChangesPreviewTable from './Table';

const t = {
  CANCEL: {
    confirm: 'Yes, cancel recurring order',
    cancel: 'Do not cancel',
    title: 'Are you sure you want to cancel these orders?',
    no_changes: "There's no orders to cancel",
  },
  EDIT: {
    confirm: 'Yes, update recurring order',
    cancel: 'Cancel changes',
    title: 'Are you sure you want make these changes?',
    no_changes: "There's no changes to apply",
  },
};

class RoChangesPreviewModal extends Component {
  constructor(props) {
    super(props);

    this.getButtonSkin = this.getButtonSkin.bind(this);
  }

  getButtonSkin() {
    const { action } = this.props;
    return action === EDIT ? 'secondary' : 'cancel';
  }

  render() {
    const { loading, submitting, shipperOrders, action, onClick, onCancel, onClose } = this.props;

    if (loading) {
      return (
        <Modal
          onClose={onClose}
          show={true}
          size="L"
          headerComponent={t[action].title}
          subHeaderComponent={null}
        >
          <StyledLoading />
        </Modal>
      );
    }

    return (
      <Modal
        show={true}
        size="L"
        headerComponent={t[action].title}
        subHeaderComponent={null}
        onClose={onClose}
      >
        {/**
         * TODO: RECURRING
         *
         * Add a tag with holidays info,
         * Last info I have is that shipper orders here may accept a
         * another status that will be HOLIDAYS
         * So we need to split this array in 2 or similar and use
         * the holidays for the tag
         * and the rest for the table
         *
         */}
        <Fragment>
          {shipperOrders.length === 0 ? (
            <Spacer mBottom="S">
              {' '}
              <Text text={t[action]['no_changes']} display="block" />{' '}
            </Spacer>
          ) : (
            <ROChangesPreviewTable shipperOrders={shipperOrders} action={action} />
          )}
          {
            <Flexer.Parent>
              <Button onClick={onClick} text={t[action].confirm} disabled={submitting} />
              {submitting && (
                <Spacer mLeft="S">
                  <StyledLoading />
                </Spacer>
              )}
              {!submitting && (
                <Flexer.Parent alingContent="center" mLeft="XS">
                  <Link text={t[action].cancel} skin={this.getButtonSkin()} onClick={onCancel} />
                </Flexer.Parent>
              )}
            </Flexer.Parent>
          }
        </Fragment>
      </Modal>
    );
  }
}

RoChangesPreviewModal.propTypes = {
  action,
  loading: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  shipperOrders: PropTypes.array.isRequired,
};

RoChangesPreviewModal.defaultProps = {
  action: 'EDIT',
};

const mapStateToProps = (state, ownProps) => ({
  shipperOrders: getPreviewChanges(state),
  action: getPreviewModalMode(state),
  loading: getPreviewModalLoading(state),
  submitting: getPreviewModalSubmitting(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RoChangesPreviewModal);
